module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgIHdpZHRoPSI1MHB4IiBoZWlnaHQ9IjUwcHgiIHZpZXdCb3g9IjAgMCA1MCA1MCIgPg0KCTxsaW5lIHgxPSIyNSIgeTE9IjEzLjEiIHgyPSIyNSIgeTI9IjM2LjkiLz4NCgk8bGluZSB4MT0iMzYuOSIgeTE9IjI1IiB4Mj0iMTMuMSIgeTI9IjI1Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/add.svg
// module id = ./node_modules/graphcool-styles/icons/stroke/add.svg
// module chunks = 0